var numeric = '[0-9]+'
var alphanumeric = '[A-Z $%*+\\-./:]+'
var kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

var byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ').)+'

export let KANJI = new RegExp(kanji, 'g')
export let BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
export let BYTE = new RegExp(byte, 'g')
export let NUMERIC = new RegExp(numeric, 'g')
export let ALPHANUMERIC = new RegExp(alphanumeric, 'g')

var TEST_KANJI = new RegExp('^' + kanji + '$')
var TEST_NUMERIC = new RegExp('^' + numeric + '$')
var TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

export function testKanji(str) {
  return TEST_KANJI.test(str)
}

export function testNumeric(str) {
  return TEST_NUMERIC.test(str)
}

export function testAlphanumeric(str) {
  return TEST_ALPHANUMERIC.test(str)
}
